// Bus de eventos automático: se dispara solo, sin que nadie tenga que
// acordarse de emitir nada. src/supabase.js intercepta CUALQUIER
// insert/update/upsert/delete sobre CUALQUIER tabla y llama a
// emitDataChanged() automáticamente. Esto es lo que hay que usar para
// suscribirse — no hace falta tocar este archivo al agregar funcionalidad.
const target = new EventTarget();
const EVENT = 'data-changed';

export function emitDataChanged(table, action, payload) {
  target.dispatchEvent(new CustomEvent(EVENT, { detail: { table, action, payload } }));
}

// handler(detail). Si se pasa `tables` (string o array), el handler solo
// se llama cuando cambia alguna de esas tablas.
export function onDataChanged(handler, tables = null) {
  const list = tables ? (Array.isArray(tables) ? tables : [tables]) : null;
  const listener = (e) => {
    if (list && !list.includes(e.detail.table)) return;
    handler(e.detail);
  };
  target.addEventListener(EVENT, listener);
  return () => target.removeEventListener(EVENT, listener);
}
